<template>
  <div class="bill-edit">
    <div class="bill-form" v-if="!$parent.preview">
      <div class="bill-form-header">
        <div class="a-left">
          <div class="input-block input-block__line">
            <div class="input-label">Счет №</div>
            <div class="input-frame input-num">
              <el-input
                placeholder="Номер счета"
                v-model="data.name"
              ></el-input>
            </div>
          </div>
          <div class="input-block input-block__line">
            <div class="input-label">от</div>
            <div class="input-frame input-date">
              <el-date-picker
                v-model="date"
                type="date"
                placeholder=""
                format="dd.MM.yyyy"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="bill-form-main">
        <div class="bill-form-req">
          <div class="bill-form-req__left bill-form-req__company">
            <div class="input-block">
              <el-select v-model="data.me.type">
                <el-option
                  v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input-block">
              <el-input
                v-model="data.me.inn"
                placeholder="ИНН Компании"
                v-if="false"
              ></el-input>
            </div>



            <div class="input-block">
              <div class="company-select company-selected">
                <div class="compyny-seelct__name">
                  {{ $root.app.user.data.name.short_with_opf }}
                </div>
                <div class="compyny-seelct__info">
                  ИНН: {{ $root.app.user.data.inn }};
                  <span v-if="$root.app.user.data.inn.length == 10"
                    >КПП: {{ $root.app.user.data.kpp }};</span
                  >
                </div>
              </div>
            </div>
            <div class="input-block">
              <div class="input-label">Основание платежа</div>

              <el-input
                v-model="data.found"
                type="textarea"
                autosize
                placeholder="Договор N108 от 15.07.2020 года"
              ></el-input>
            </div>
            <div class="input-block">
              <div class="input-label">Назначение оплаты</div>

              <el-input
                v-model="data.purpose"
                type="textarea"
                autosizes
                placeholder="Оплата по счету №11111 от 10.11.2020"
              ></el-input>
            </div>

            <div
              class="input-block action-input"
              v-if="$root.app.user.nds == '1'"
            >
              <el-switch
                v-model="data.nds"
                active-color="#13ce66"
                inactive-color="#bcc5cf"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
              <div class="input-label">Цена включает НДС</div>
            </div>
          </div>
          <div class="bill-form-req__right bill-form-req__company">
            <div class="input-block">
              <el-select v-model="data.customer.type">
                <el-option
                  v-for="item in types_b"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            
            <div class="input-block">
              <div class="company-select company-selected">
                <div class="compyny-seelct__name">
                  {{ data.customer.data.name.short_with_opf }}
                </div>
                <div class="compyny-seelct__info">
                  ИНН: {{ data.customer.inn }};
                  <span v-if="data.customer.inn.length == 10"
                    >КПП: {{ data.customer.data.kpp }};</span
                  >
                </div>
                <a class="close-button">
                  <div
                    class="close-icon"
                    v-html="$root.icons.cross"
                    @click="$parent.modal_cust = true"
                  ></div>
                </a>
              </div>
            </div>

            <div class="input-block">
              <div class="input-label">Коментарий к платежу</div>

              <el-input
                v-model="data.description"
                type="textarea"
                autosizes
                placeholder="1. Cчет действителен в течение пяти банковских дней."
              ></el-input>
            </div>
          </div>
        </div>

        <div class="bill-form-items">
          <div class="bill-form-item-one bill-form-item-one__title">
            <div class="item-one-el item-one-name">
              <span>Наименование товаров, работ, услуг</span>
            </div>
            <div class="item-one-el item-one-count">
              <span>Кол-во</span>
            </div>
            <div class="item-one-el item-one-counttype">
              <span>Ед.изм</span>
            </div>
            <div class="item-one-el item-one-cost">
              <span>Цена</span>
            </div>
            <div
              class="item-one-el item-one-nds"
              v-if="$root.app.user.nds == '1'"
            >
              <span>НДС</span>
            </div>
            <div class="item-one-el item-one-sum">
              <span>Сумма</span>
            </div>
          </div>

          <draggable
            class="list-group"
            tag="div"
            @start="drag = true"
            @end="drag = false"
            handle=".handle"
            v-model="data.items"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <div
                class="bill-form-item-one"
                v-for="(item, index) in data.items"
                :key="item.id"
              >
                <div class="handle" v-if="data.items.length > 1">
                  <div class="handle-icon" v-html="$root.icons.handle"></div>
                </div>
                <div class="item-one-el item-one-name">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="Введите название"
                    v-model="item.name"
                  >
                  </el-input>
                </div>
                <div class="item-one-el item-one-count">
                  <vuenumeric
                    v-model="item.count"
                    :min="0"
                    separator="space"
                    v-bind:precision="0"
                    v-bind:minus="false"
                    class="table-input"
                  >
                  </vuenumeric>
                </div>
                <div class="item-one-el item-one-counttype">
                  <el-autocomplete
                    v-model="item.type"
                    :fetch-suggestions="querySearch"
                  ></el-autocomplete>
                </div>
                <div class="item-one-el item-one-cost">
                  <vuenumeric
                    separator="space"
                    decimal-separator="."
                    v-model="item.cost"
                    v-bind:precision="2"
                    v-bind:minus="false"
                    class="table-input"
                    :currency="'₽'"
                    currency-symbol-position="suffix"
                  >
                  </vuenumeric>
                </div>
                <div
                  class="item-one-el item-one-nds"
                  v-if="$root.app.user.nds == '1'"
                >
                  <el-select v-model="item.nds">
                    <el-option
                      v-for="item in $root.app.nds_types"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="item-one-el item-one-sum">
                  <div class="sum-text">
                    {{ (item.cost * item.count) | money }}
                  </div>
                </div>
                <div class="table-item-remove" @click="remove(index)">
                  <div class="remove-icon" v-html="$root.icons.trash_2"></div>
                </div>
              </div>
            </transition-group>
          </draggable>

          <div class="bill-form-item-one bill-form-item-one__titled">
            <div class="item-one-el item-one-name">
              Итого
              <span v-if="$root.app.user.nds == '1' && data.nds == '1'"
                >, вкл. НДС</span
              >
            </div>
            <div class="item-one-el item-one-sum">
              <div class="sum-text">
                {{ sum | money }}
              </div>
            </div>
          </div>

          <div
            class="bill-form-item-one bill-form-item-one__titled"
            v-if="$root.app.user.nds == '1'"
            v-for="el in nds_data"
            :key="el.id"
          >
            <div class="item-one-el item-one-name">НДС {{ el.id }}%</div>
            <div class="item-one-el item-one-sum">
              <div class="sum-text">
                {{ el.sum | money }}
              </div>
            </div>
          </div>
          <div
            class="bill-form-item-one bill-form-item-one__titled"
            v-if="$root.app.user.nds == '1'"
          >
            <div class="item-one-el item-one-name">Всего к оплате</div>
            <div class="item-one-el item-one-sum">
              <div class="sum-text">
                {{ ((data.nds == "0" ? nds : 0) + sum) | money }}
              </div>
            </div>
          </div>
          <div class="button-group">
            <a class="button" @click="addBillItem">Добавить позицию</a>
          </div>
        </div>
      </div>
    </div>
    <div class="bill-actions">
      <div
        class="action-one preview"
        @click="$parent.preview = !$parent.preview"
      >
        <a class="button btn-light">
          <div
            class="button-icon"
            v-html="$parent.preview ? $root.icons.edit : $root.icons.eye"
          ></div>
          {{ !$parent.preview ? "Предпросмотр" : "К редактированию" }}</a
        >
      </div>
      <div class="action-one">
        <a class="button" @click="$root.app.openSend = true;">
          <div class="button-icon" v-html="$root.icons.send"></div>
          Отправить</a
        >
      </div>
      <div class="action-group">
        <div class="action-one">
          <a class="button btn-dark" @click="get('pdf')">
            <div class="button-content" v-if="!load_pdf">
              <div class="button-icon" v-html="$root.icons.download"></div>
              Pdf
            </div>
            <el-progress
              v-if="load_pdf"
              :percentage="progress_pdf"
            ></el-progress
          ></a>
        </div>
        <div class="action-one">
          <el-tooltip
            class="item"
            effect="dark"
            content="Доступно в PRO"
            placement="top-start"
          >
            <a class="button btn-dark" disabled>
              <div class="button-content" v-if="!load_word">
                <div class="button-icon" v-html="$root.icons.download"></div>
                Word
              </div>
              <el-progress
                v-if="load_word"
                :percentage="progress_word"
              ></el-progress>
            </a>
          </el-tooltip>
        </div>
        <div class="action-one action-one__short" @click="print">
          <a class="button btn-dark">
            <div class="button-icon" v-html="$root.icons.print"></div>
          </a>
        </div>
      </div>
      <div class="action-form">
        <div class="action-input">
          <div class="action-label">QR код</div>
          <div class="action-input-block">
            <el-switch
              v-model="data.qr"
              active-color="#13ce66"
              inactive-color="#bcc5cf"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </div>
        </div>

        <div class="action-input qr-block" v-if="data.qr == '1'">
          <vue-qrcode :value="qrdata" :options="opts"></vue-qrcode>
        </div>

        <div class="action-input">
          <div class="action-label">Ссылка на счет</div>
          <div class="action-input-block">
            <el-switch
              v-model="data.link"
              active-color="#13ce66"
              inactive-color="#bcc5cf"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </div>
        </div>

        <div class="action-input input-link" v-if="data.link == '1'">
          <el-input
            placeholder="Please input"
            v-model="data.link_value"
          ></el-input>
          <a
            class="btn-small"
            v-clipboard="() => data.link_value"
            v-clipboard:success="clipboardSuccessHandler"
          >
            <div class="share-icon" v-html="$root.icons.link"></div>
          </a>
        </div>
      </div>

      <Story />
    </div>
    <Watch :data="data" />
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import draggable from "vuedraggable";

import vuenumeric from "../numeric.vue";
import bl_inn from "../bl-inn.vue";

import VueQrcode from "@chenfengyuan/vue-qrcode";
import Watch from "../watch.vue";

import Story from "../bl-story.vue";

export default {
  name: "Bills",
  props: ["data"],
  components: {
    VueQrcode,
    Watch,
    draggable,
    vuenumeric,
    Story,
    bl_inn
  },
  data: () => {
    return {
      load: false,
      menu: false,
      update: true,
      v1: "",
      drag: false,
      load_pdf: false,
      load_word: false,
      date: "",
      types: [
        { id: 0, name: "Поставщик" },
        { id: 1, name: "Продавец" },
        { id: 2, name: "Исполнитель" },
        { id: 3, name: "Лицензиар" },
      ],
      types_b: [
        { id: 0, name: "Клиент" },
        { id: 1, name: "Покупатель" },
        { id: 2, name: "Заказчик" },
        { id: 3, name: "Лицензиат" },
      ],
      search_inn: false,
      opts: {
        width: 270,
        errorCorrectionLevel: "Q",
        margin: 1,
        type: "image/png",
        color: {
          dark: "#344d6c",
          light: "#344d6c00",
        },
      },
      links: [
        { value: "шт." },
        { value: "ед." },
        { value: "упак." },
        { value: "компл." },
        { value: "усл. ед." },
        { value: "литр" },
        { value: "кг" },
        { value: "м³" },
        { value: "м²" },
      ],
      progress_pdf: 0,
      int_pdf: 0,
      progress_word: 0,
      int_word: 0,
    };
  },
  computed: {
    sum: function () {
      var sum = 0;
      this.data.items.forEach((el) => {
        sum += el.cost * el.count;
      });

      return sum;
    },
    nds: function () {
      let nds = 0;
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;

        nds += (sum * nds_value) / (d + 100);
      });

      return nds;
    },
    nds_data: function () {
      let nds = [];
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;
        if (!nds.find((x) => x.id == nds_value))
          nds.push({ id: nds_value, sum: 0 });

        nds.find((x) => x.id == nds_value).sum += (sum * nds_value) / (d + 100);
      });

      return nds;
    },

    qrdata: function () {
      var params = {
        Name: this.$root.app.user.data.name.full_with_opf,
        PersonalAcc: this.$root.app.user.bank.rs,
        BankName: this.$root.app.user.bank.data.name.payment,
        BIC: this.$root.app.user.bank.data.bic,
        CorrespAcc: this.$root.app.user.bank.data.correspondent_account,
        PayeeINN: this.$root.app.user.data.inn,
        KPP: this.$root.app.user.data.kpp,
        Purpose: this.data.purpose
          ? this.data.purpose
          : "Оплата счета №" +
            this.data.name +
            " от " +
            this.$moment(this.data.date).format("DD.MM.YYYY"),
        Sum: ((this.data.nds == "0" ? this.nds : 0) + this.sum) * 100,
      };

      var s = "ST00011";
      for (let key in params) {
        s += "|" + key + "=" + params[key];
      }
      return s;
    },
  },
  methods: {
    remove(index) {
      this.data.items.splice(index, 1);
    },
    get(type) {
      this["load_" + type] = true;
      this["progress_" + type] = 0;

      this["int_" + type] = setInterval(() => {
        this["progress_" + type] += 1;

        if (this["progress_" + type] >= 100) {
          clearInterval(this.int);
        }
      }, 187.5);


      axios
        .get(this.$root.app.way + "/ajax/", {
          params: {
            action: "get-file",
            type: type,
            hash: this.data.hash,
          },
          responseType: "blob",
        })
        .then((response) => {
          clearInterval(this["int_" + type]);
          this["int_" + type] = setInterval(() => {
            this["progress_" + type] += 1;
            if (this["progress_" + type] >= 100) {
              clearInterval(this["int_" + type]);
              setTimeout(() => {
                this["load_" + type] = false;
                //window.location = response.data.link;
                var a = document.createElement("a");
                var url = window.URL.createObjectURL(new Blob([response.data]));
                a.href = url;
                a.download =
                  "Cчет №" + this.data.name + " от " + this.data.date + ".pdf";
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              }, 250);
            }
          }, 10);
        })
        .catch(() => {
          this["load_" + type] = false;
          this.$message({
            message: "Произошла ошибка, попробуйте еще раз позже!",
            type: "error",
          });
        });
    },
    print() {
      window.print();
    },
    addBillItem() {
      this.data.items.push({
        id: this.givmehash(),
        name: "",
        count: 1,
        type: "",
        cost: 0,
        nds: 3,
      });
    },
    givmehash() {
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP";
      var hash = "",
        length = 6;
      for (var x = 0; x < length; x++) {
        var i = Math.floor(Math.random() * chars.length);
        hash += chars.charAt(i);
      }
      return hash;
    },
    querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    clipboardSuccessHandler() {
      this.$message({
        message: "Ссылка скопирована в буфер",
        type: "success",
      });
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    getCompany() {
      this.search_inn = true;
      axios
        .get(
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party",
          {
            params: {
              token: "bf05fcc5d2c1055cceb60af0efbd46684c2755a1",
              branch_type: "MAIN",
              query: this.data.customer.inn,
            },
          }
        )
        .then((response) => {
          this.data.customer.data = response.data.suggestions[0].data;
          this.search_inn = false;
        })
        .catch(() => {
          this.search_inn = false;
          this.$message({
            message: "Произошла ошибка, попробуйте еще раз позже!",
            type: "error",
          });
        });
    },
  },
  watch: {
    "data.customer.inn": {
      handler: _.debounce(function () {
        this.getCompany();
      }, 1000),
      deep: true,
    },
  },
  mounted() {
    this.date = new Date(this.data.date);

    this.$watch("date", (value) => {
      let temp = this.$moment(value);
      this.data.date = temp.format("YYYY-MM-DD");
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.bill-edit {
  width: 100%;
}
.bill-form {
  overflow: hidden;
}
.bill-form-header {
  padding: 24px 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
}

.input-block {
  & + .input-block {
    margin-top: 24px;
  }
  .input-label {
    color: #99a6b7;
    font-size: 13px;
    white-space: nowrap;
    margin-bottom: 8px;
  }
  &.input-block__line {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: stretch;
    .input-label {
      margin-right: 12px;
      margin-bottom: 0;
    }
  }
  &.input-block__line + .input-block__line {
    margin-left: 16px;
    margin-top: 0;
  }
}
.a-left {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
}
.a-right {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
}
.input-frame.input-num {
  width: 114px;
}
.qr-block {
  margin-top: 16px;
}
.input-frame.input-date {
  width: 130px;
}
.bill-form-req {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}
.el-input {
  width: 100%;
}
.bill-form-req__left {
  width: 50%;
}

.bill-form-req__right {
  width: 50%;
}
.bill-form-req__company .el-select {
  width: 100%;
}

.bill-form-req__left.bill-form-req__company {
  padding-right: 32px;
  border-right: 1px dashed rgba(0, 0, 0, 0.1);
}
.flip-list-move {
  transition: transform 0.5s;
}
.bill-form-req__right.bill-form-req__company {
  padding-left: 32px;
}
.company-block {
  width: 100%;
  color: #0059fc;
  background: #f4f8ff;
  padding: 18px 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

.company-block__title {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
}

.company-block__line {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  font-size: 13px;
}

.company-block__name {
  width: 76px;
  font-weight: 500;
  flex-shrink: 0;
}
h3.company-name-one {
  margin-top: 28px;
  font-size: 18px;
  font-weight: 500;
}
.action-form {
  margin-top: 32px;
  padding-top: 18px;
  border-top: 1px solid #ebeef3;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

.action-input {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
  /* margin-left: auto; */
}

.action-label {
  font-size: 15px;
  font-weight: 500;
}
.action-input-block {
  margin-left: auto;
}
.action-input + .action-input {
  margin-top: 20px;
}
.action-input.input-link input.el-input__inner {
  background-color: rgba(3, 104, 250, 0.15);
  color: #0368fa !important;
}
.share-icon {
  height: 36px;
  width: 36px;
  margin-left: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  background-color: #0368fa;
  border-radius: 4px;
  cursor: pointer;
}

.share-icon svg {
  height: 20px;
  width: 20px;
  stroke: #fff;
}

.share-icon:hover {
  background-color: #0246a7;
}
a.button.btn-change {
  margin-top: 16px;
}
#app a.button.btn-change {
  height: 28px;
  width: 28px;
  padding: 0;
  margin-top: 0;
  margin-right: 12px;
}

#app a.button.btn-change svg {
  height: 16px;
  width: 16px;
}

.buttin-icon {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
}
.bill-form-items {
  margin-top: 24px;
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

.bill-form-item-one {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  padding: 0 32px 0 0;
}
.item-one-el {
  font-size: 12px;
  input,
  textarea {
    font-size: 12px;
  }
}

.item-one-el + .item-one-el {
  margin-left: 8px;
}

.item-one-el.item-one-name {
  flex-grow: 1;
  width: 320px;
}

.item-one-el.item-one-count {
  width: 78px;
}

.item-one-el.item-one-counttype {
  width: 80px;
}

.item-one-el.item-one-cost {
  width: 120px;
}
.item-one-el.item-one-sum {
  width: 140px;
}
.item-one-el > span {
  display: inline-block;
  width: 100%;
}
.item-one-el.item-one-cost input,
.item-one-el.item-one-cost > span {
  text-align: right;
}
.item-one-el.item-one-counttype input,
.item-one-el.item-one-counttype > span {
  text-align: right;
}
.item-one-el.item-one-count input,
.item-one-el.item-one-count > span {
  text-align: right;
}

.item-one-el.item-one-sum {
  text-align: right;
}
.bill-form-item-one.bill-form-item-one__title .item-one-el > span {
  font-weight: 500;
  font-size: 13px;
}
.bill-form-item-one.bill-form-item-one__title {
  margin-bottom: 16px;
}
.handle {
  width: 32px;
  height: 36px;
  margin-right: 4px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  cursor: grab;
}

.handle-icon {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
}

.handle-icon svg {
  height: 17px;
  stroke: #3a5171;
  opacity: 0.5;
  transition: 0.25s;
}

.handle:hover svg {
  opacity: 1;
}
.sum-text {
  height: 36px;
  font-size: 12px;
  line-height: 36px;
}
.button-group {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
}

#app .button-group .button {
  width: auto;
}
.bill-form-item-one + .bill-form-item-one {
  margin-top: 12px;
}
.bill-form-item-one.bill-form-item-one__titled {
  margin-top: 24px;
}

.bill-form-item-one.bill-form-item-one__titled .item-one-el.item-one-name {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  align-content: stretch;
  font-weight: 500;
  font-size: 13px;
}

.bill-form-item-one.bill-form-item-one__titled .item-one-el.item-one-sum {
  font-weight: 500;
  font-size: 13px;
  min-width: 140px;
  width: auto;
}
.input-block.action-input {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

.input-block.action-input .el-switch {
  margin-right: 12px;
}
.bill-form-item-one.bill-form-item-one__titled
  + .bill-form-item-one.bill-form-item-one__titled {
  margin-top: 0;
}
.bill-form-item-one.bill-form-item-one__titled span {
  width: auto;
}
.item-one-el.item-one-nds {
  width: 80px;
}

.button-content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
}
#app .action-one .el-progress__text {
  color: #fff;
  font-size: 11px !important;
  top: 6px;
  left: 0;
  position: absolute;
}

#app .action-one .el-progress {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
}

#app .action-one .el-progress-bar {
  top: 24px;
  position: absolute;
  width: 153px;
}

#app .action-one .el-progress-bar .el-progress-bar__outer {
  border-radius: 0;
  width: 100%;
  background-color: #f7f8f9;
  height: 5px !important;
}

#app
  .action-one
  .el-progress-bar
  .el-progress-bar__outer
  .el-progress-bar__inner {
  border-radius: 0;
  transition: none;
}
.remove-icon svg {
  height: 17px;
  stroke: #3a5171;
  opacity: 0.5;
  transition: 0.25s;
}

.table-item-remove {
  position: absolute;
  top: 4px;
  right: -22px;
  width: 32px;
  height: 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  cursor: pointer;
}

.bill-form-item-one {
  position: relative;
}

.table-item-remove:hover svg {
  opacity: 1;
  stroke: rgba(220, 53, 69, 1);
}
a.bill-action-one.bill-action-one__remove:hover svg {
  stroke: rgba(220, 53, 69, 1);
}
</style>
